export default "__VITE_ASSET__CXMPBaP0__"